export interface PS {
	nom: string;
	prenom: string;
	numAM: string;
	numRPPS: string;
	typeIdentifiant: string;
	raisonSociale: string;
	mail: string;
	categorie: string;
	specialite: string;
}

export interface Patient {
	nir: string;
	dateNaissance: string;
	rangNaissance: string;
}

export class InfosPSBEN {
	ps: PS;
	assure: Patient;
	beneficiaire: Patient;

	constructor(data: { infosPS: PS, numRpps: string, assure: Patient, beneficiaire: Patient }) {
		this.ps = data.infosPS;
		if (data.numRpps !== undefined) {
			this.ps.numRPPS = data.numRpps;
		}

		this.assure = data.assure;
		this.beneficiaire = data.beneficiaire;
	}
}

export interface InfosPSBENState {
	infosPSBEN?: InfosPSBEN;
	error: boolean;
	loaded: boolean;
	approvalDashboard: boolean | undefined;
	displayErrorDashboard: boolean | undefined;
	extensionSessionAvailable: boolean | undefined;
	expirationTs: number | undefined;
	extensions: number | undefined;
	delayDisplaySession: number | undefined;
	nirUrgenceEnabled: boolean;
	vaccinationSearchToDisplay: number;
	folderDegradeSearchEnabled: boolean;
}
